import React, { ReactElement, useMemo, useState } from "react";
import { useUsers } from "../users";
import { Call } from "./Call";
import { DialerCallButton } from "./DialerCallButton";
import { DialerNotesForm } from "./DialerNotesForm";

interface IParams {
	leadId: string;
}

export const Dialer = (props: IParams): ReactElement => {
	const [call, setCall] = useState<Call>();
	const [phoneNumber, setPhoneNumber] = useState<string>("");
	const [isCalling, setIsCalling] = useState<boolean>(false);
	const [callCompleted, setCallCompleted] = useState<boolean>(false);

	const userContext = useUsers();

	useMemo(() => {
		const phoneNumberField = document.getElementById(
			"phone",
		) as HTMLTextAreaElement;
		if (phoneNumberField) {
			setPhoneNumber(phoneNumberField.value);
		}
	}, []);

	const handleCallInitialed = (dialerCall: Call) => {
		setCall(dialerCall);
		setCallCompleted(false);
		setIsCalling(true);
	};

	const handleCallStateChange = (dialerCall: Call) => {
		setCall(dialerCall);
		if (dialerCall.state === "hangup") {
			setCallCompleted(true);
			setIsCalling(false);
		}
	};

	const handleNotesSave = () => {
		setCallCompleted(false);
	};

	if (!userContext.user || !userContext.user.dialerId) {
		return <div />;
	}

	return (
		<>
			<div
				style={{
					width: "100%",
					textAlign: "center",
					padding: 30,
					marginTop: -50,
					marginBottom: 30,
					background: isCalling ? "#01bda5" : "#e6e6e6",
					color: isCalling ? "white" : "#000",
				}}
			>
				<DialerCallButton
					leadId={props.leadId}
					number={phoneNumber}
					onCallInitiated={handleCallInitialed}
					onCallStateChange={handleCallStateChange}
				/>
				{isCalling ? (
					<h3 className="mt-3 mb-3">
						{call ? call.state.toUpperCase() : ""}
					</h3>
				) : null}

				<DialerNotesForm
					leadId={props.leadId}
					showNotesEditor={isCalling || callCompleted}
					showSaveButton={callCompleted}
					callDuration={call ? call.duration : 0}
					callId={call && call.daialerCallId ? call.daialerCallId : 0}
					onSave={handleNotesSave}
				/>
			</div>
		</>
	);
};
